import React from 'react';
import classNames from 'classnames';
import { LISTING_PACKAGE, ListingPackage } from 'models/Listing';
import GetBuyers from 'router/subrouters/ListingCreationWizard/components/GetBuyers';

import './ListingOptions.styles.scss';

const OPTIONS: ListingPackage[] = [
  LISTING_PACKAGE.COMPREHENSIVE,
  LISTING_PACKAGE.BASIC,
  LISTING_PACKAGE.NO_PACKAGE,
];

type ListingOptionsProps = {
  className?: string;
};

const ListingOptions: React.FC<ListingOptionsProps> = (props) => {
  const { className } = props;

  const classes = classNames('listing-options', 'lcw-page', className);

  return <GetBuyers className={classes} options={OPTIONS} />;
};

export default ListingOptions;
